import Token from 'markdown-it/lib/token';

import { BaseExtension, NodeSpec } from '@lyearn/lygo-core';

import { DEFAULT_LANGUAGE } from '../CodeBlock/consts';

export default class CodeFence extends BaseExtension {
  get name(): string {
    return 'code_fence';
  }

  get schema(): NodeSpec {
    return {
      attrs: {
        language: {
          default: DEFAULT_LANGUAGE,
        },
        id: { default: null },
      },
      content: 'text*',
      marks: '',
      group: 'block',
      code: true,
      defining: true,
      parseDOM: [
        {
          tag: 'pre',
          preserveWhitespace: 'full',
        },
        {
          tag: 'div.code-block',
          preserveWhitespace: 'full',
          contentElement: 'code',
          getAttrs: (dom: any) => {
            return {
              language: dom.dataset.language,
            };
          },
        },
        {
          tag: '.code-block',
          preserveWhitespace: 'full',
          contentElement: (node: any) => node.querySelector('code') || node,
          getAttrs: (dom: any) => {
            return {
              language: dom.dataset.language,
            };
          },
        },
      ],
      toDOM: (node) => {
        return [
          'div',
          {
            class: 'code-block',
            'data-language': node.attrs.language,
            id: node.attrs.id,
          },
          [
            'pre',
            {
              class: 'p-24 text-text-paragraph mt-12',
            },
            ['code', { spellCheck: 'false' }, 0],
          ],
        ];
      },
    };
  }

  get markdownToken(): string {
    return 'fence';
  }

  parseMarkdown() {
    return {
      block: 'code_block',
      getAttrs: (tok: Token) => ({ language: tok.info }),
    };
  }
}
